import { computed, onMounted, ref } from 'vue'

export default function useFixFormAutofill() {
  const isAutofillPassword = ref(false)
  const isAutofillEmail = ref(false)

  const emailPlaceholder = computed(() => (isAutofillEmail.value ? ' ' : null))
  const passwordPlaceholder = computed(() => (isAutofillPassword.value ? ' ' : null))

  onMounted(() => {
    // проверка на автозаполнение в хроме
    setTimeout(() => {
      if (typeof document !== 'undefined') {
        if (document.querySelectorAll('input[name="password"]:-webkit-autofill').length) {
          isAutofillPassword.value = true
        }

        if (
          document.querySelectorAll('input[name="username"]:-webkit-autofill').length
          || document.querySelectorAll('input[name="email"]:-webkit-autofill').length
        ) {
          isAutofillEmail.value = true
        }
      }
    }, 100)
  })

  return {
    emailPlaceholder,
    passwordPlaceholder,
  }
}
